import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LanguageSelector from 'components/shared/LanguageSelector';
import ThemeModeToggle from 'components/shared/ThemeModeToggle';
import AuthCard from 'components/auth/portal/AuthCard';
import StyledAuthBackdrop from 'common/theme/layouts/auth/StyledAuthBackdrop';

/**
 * Shell de TODAS las pantallas públicas. Fondo en gradiente off-black (mode-aware,
 * ya sin foto a pantalla completa) + card único (rail + hero + formularios).
 * Como todas las rutas públicas comparten este layout, React lo PRESERVA al navegar
 * entre ellas: el card persiste y el rail/hero animan entre vistas.
 */
function LoginLayout({ children }) {
  const { i18n } = useTranslation();

  return (
    <StyledAuthBackdrop>
      <Box
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          zIndex: 10,
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          color: 'text.primary'
        }}>
        <ThemeModeToggle color="inherit" />
        <LanguageSelector
          selectedLanguage={i18n.language}
          onSelect={(lang) => i18n.changeLanguage(lang)}
          color="inherit"
        />
      </Box>
      <AuthCard>{children}</AuthCard>
      {/* Notifier vive UNA sola vez en router/index.js (montarlo aquí duplicaba toasts). */}
    </StyledAuthBackdrop>
  );
}

LoginLayout.propTypes = {
  children: PropTypes.element.isRequired
};

export default LoginLayout;
